import WidgetModule from "@eisinc/Overrides/Widgets/Header/SecondaryNavigation";

export * from "@eisinc/Overrides/Widgets/Header/SecondaryNavigation";

export default WidgetModule;
